import React, {useState} from "react";
import Swal from "sweetalert2";

const SearchModal = ({ getClientes, setIsSearched}) => {
    const [search, setSearch] = useState('')
    const [option, setOption] = useState('')

    const showError = ({ message }) => {
        Swal.fire({
            icon: 'warning',
            title: 'Oops...',
            text: message,
        })
    }
    const handleChangeOption = (e) => {
        setOption(e.target.value)

    }
    const handleChangeSearch = (e) => {
        setSearch(e.target.value)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        switch (option) {
            case "":
                showError({ message: 'Seleccione una opción de búsqueda' })
                break;
            case "name":
                if (!search) return showError({ message: "Escriba un Nombre" });
                getClientes({ page: 1, [option]: search })
                setIsSearched({
                    option,
                    search,
                    state: true
                })
                break

            case "mail":
                if (!search) return showError({ message: "Escriba un Correo" });
                getClientes({ page: 1, [option]: search })
                setIsSearched({
                    option,
                    search,
                    state: true
                })
                break
            default:
                getClientes({})
                break
        }
    }

    return (
        <div>
            <div className="row mb-2">
                <h6>Busqueda de Clientes:</h6>
            </div>
            <div className="table-responsive rounded-3 d-flex justify-content-center" style={{ border: '1px solid black', paddingTop: '10px' }}>
                <>
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <select onChange={handleChangeOption} id="busquedaModal" className="form-select" aria-label="Default select example">
                                    <option value="">Seleccione</option>
                                    <option value="name">Nombre</option>
                                    <option value="mail">Correo</option>
                                </select>
                            </div>
                            <div className="col">
                                <input type="text" className="form-control" id="findModal" name="findModal" onChange={handleChangeSearch} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-center" style={{ paddingTop: '10px', paddingBlock: '10px' }}>
                            <button type="submit" className="btn btn-primary" onClick={handleSubmit}>Buscar</button>
                        </div>
                    </div>
                </>
            </div>
        </div>
    );
}
export default SearchModal;